import * as React from "react";

export interface IBusyState {
    isBusy: boolean;
    busyError: any;
}

export interface IBusyActions {
    onStart: () => void;
    onError: (error: any) => void;
    onSuccess: () => void;
}

export function useBusyState(): [IBusyState, IBusyActions] {
    const [isBusy, setIsBusy] = React.useState(false);
    const [busyError, setBusyError] = React.useState<any>(undefined);
    return [
        { 
            isBusy,
            busyError
        },
        {
            onStart: () => {
                setIsBusy(true);
                setBusyError(undefined);
            },
            onSuccess: () => {
                setIsBusy(false);
                setBusyError(undefined);
            },
            onError: (error: any) => {
                setIsBusy(false);
                setBusyError(error);
            }
        }
    ]
}